<template>
  <div>
    <div class="gamebox">
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_detail`) }}
        </div>
      </div>
      <!-- 莊家 -->
      <div class="public ">
        <div class="title">{{ $t(`lang.str_banker_poker`) }}</div>
        <div class="menu">
          <div class="item" v-for="(item,index) in bankerpoker" :key="index">
            <img :class="{ deepPos: matchDeepPos(index) }" alt=""
                 :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
          </div>
        </div>
        <div class="menu">
          <div class="wintype">
            {{bankerPokerPoint + $t(`lang.str_card_point`)}}
          </div>
        </div>
      </div>
      <!-- 闲家 -->
      <div class="public ">
        <div class="title"> {{ $t(`lang.str_player_poker`) }}</div>
        <div class="menu">
          <div class="item" v-for="(item,index) in handpoker" :key="index">
            <img :class="{ deepPos: matchDeepPos(index) }" alt=""
                 :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
          </div>
        </div>
        <div class="menu">
          <div class="wintype">
            {{handlerPokerPoint + $t(`lang.str_card_point`)}}
          </div>
        </div>

      </div>
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_betDetail`) }}
        </div>
      </div>
      <div class="jokerbet2">
        <div>
          <div class="detail">
            <div class="item" v-for="(item, index) in winpos" :key="index">
                    <span v-if="index==0">{{ $t(`lang.str_bjl_zhuang`) }} <span style="color: #ed9108;"
                                                                                v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==1">{{ $t(`lang.str_bjl_xian`) }} <span style="color: #ed9108;"
                                                                        v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==2">{{ $t(`lang.str_bjl_zhuang_dui`) }} <span style="color: #ed9108;"
                                                                              v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==3">{{ $t(`lang.str_bjl_xian_dui`) }} <span style="color: #ed9108;"
                                                                            v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==4">{{ $t(`lang.str_bjl_he`) }} <span style="color: #ed9108;"
                                                                      v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==5">{{ $t(`lang.str_bjl_arbitrary_pair`) }}
                      <span style="color: #ed9108;" v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              <span v-if="index==6">{{ $t(`lang.str_bjl_perfect_pair`) }}
                      <span style="color: #ed9108;" v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
            </div>
          </div>
          <div class="detail">
            <p v-for="(item, index) in winpos" :key="index">
                    <span v-if="bets" class="item">
                      <span v-for="(subitem,subindex) in bets" :key="subindex">
                        <span v-if="subitem.position == index || (!subitem.position && index == 0)">
                          <p v-if="subitem.bet">
                            {{parseFloat(subitem.bet / 100).toFixed(2)}}
                          </p>
                          <p v-else>
                            0
                          </p>
                        </span>
                      </span>
                    </span>
              <span v-else>
                      0
                    </span>
            </p>
          </div>
          <div class="detail">
            <div class="item"  v-for="(item, index) in winpos" :key="index">
              <span  v-if="item>0" style="color: #ed9108;">{{ $t(`lang.str_game_win`) }}</span>
              <span v-else> {{ $t(`lang.str_game_fail`) }}</span>
            </div>
          </div>
          <div class="detail">
            <p v-for="(item, index) in winpos" :key="index">
                    <span v-if="bets" class="item">
                      <span v-for="(subitem,subindex) in bets" :key="subindex">
                        <span v-if="subitem.position == index || (!subitem.position && index == 0)">
                          <p v-if="subitem.bet">
                            <span v-if="subitem.win">
                              {{parseFloat((subitem.win-subitem.bet) / 100).toFixed(2)}}
                            </span>
                            <span v-else>
                              -{{parseFloat((subitem.bet) / 100).toFixed(2)}}
                            </span>
                          </p>
                          <p v-else>
                            0
                          </p>
                        </span>
                      </span>
                    </span>
              <span v-else>
                      0
                    </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title="describe_title"
      :describe_content="describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game2002_2004",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    bankerPokerPoint:0,
    handlerPokerPoint:0,
    bankerpoker: [],
    winpos: [],
    handpoker: [],
    bets:[],
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    matchDeepColor(index) {
      return this.mapIndex.some(item => item === index)
    },
    matchDeepPos(index) {
      return index >= 2;
    },
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/joker/game_2002_2004.vue